var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "ai-recognition-dialog",
      attrs: {
        title: _vm.title || _vm.$t("SeaExport.AiDocRecognition"),
        visible: _vm.innerVisible,
        "close-on-press-escape": false,
        "close-on-click-modal": false,
        width: "678px"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c("div", { staticClass: "upload-area" }, [
        _c(
          "p",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showTip,
                expression: "showTip"
              }
            ],
            staticClass: "support-tip",
            staticStyle: { "text-align": "left", "font-size": "16px" }
          },
          [_vm._v(_vm._s(_vm.$t("SeaExport.SupportMultipleFiles")))]
        ),
        _vm.step === 1
          ? _c("div", { staticClass: "drop-area" }, [
              _c(
                "div",
                { staticClass: "drop-info" },
                [
                  _c(
                    "el-upload",
                    {
                      ref: "upload",
                      staticClass: "el-upload-body",
                      attrs: {
                        action: "string",
                        "before-upload": _vm.beforeUpload,
                        "http-request": function(p) {
                          return (_vm.step = 2)
                        },
                        "show-file-list": false,
                        multiple: false,
                        drag: "",
                        accept:
                          ".pdf,.jpg,.jpeg,.png,.txt,.xls,.xlsx,.doc, .docx"
                      }
                    },
                    [
                      _c("img", {
                        staticClass: "drop-icon-large",
                        attrs: {
                          src: require("@/assets/icons/ai-recognition-folder.png"),
                          alt: ""
                        }
                      }),
                      _c("div", { staticClass: "el-upload__text" }, [
                        _vm._v(
                          " " + _vm._s(_vm.$t("SeaExport.DragOrClick")) + " "
                        ),
                        _c("em", [
                          _vm._v(_vm._s(_vm.$t("SeaExport.ClickUpload")))
                        ])
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "el-upload__tip",
                          attrs: { slot: "tip" },
                          slot: "tip"
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("SeaExport.FileSizeLimit")) +
                              " "
                          )
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            ])
          : _vm._e(),
        _vm.step === 2
          ? _c("div", { staticClass: "preview-area" }, [
              _c(
                "div",
                { staticClass: "preview-info" },
                [
                  _c("img", {
                    staticClass: "drop-icon-large",
                    attrs: {
                      src: require("@/assets/icons/ai-recognition-pdf.png"),
                      alt: ""
                    }
                  }),
                  _c("span", { staticClass: "file-name" }, [
                    _vm._v(_vm._s(_vm.currentFile.name))
                  ]),
                  _c(
                    "el-button",
                    {
                      staticClass: "button-reupload-text",
                      attrs: { type: "text" },
                      on: { click: _vm.resetData }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Reupload")) + " ")]
                  )
                ],
                1
              )
            ])
          : _vm._e(),
        _vm.step === 3
          ? _c("div", { staticClass: "progress-area" }, [
              _c(
                "div",
                { staticClass: "progress-info" },
                [
                  _c("img", {
                    staticClass: "progress-icon-large",
                    attrs: {
                      src: require("@/assets/icons/ai-recognition-pdf.png"),
                      alt: ""
                    }
                  }),
                  _c("p", { staticClass: "progress-tip" }, [
                    _vm._v(_vm._s(_vm.$t("SeaExport.RecognitionInProgress")))
                  ]),
                  _c("el-progress", {
                    staticClass: "progress-bar",
                    attrs: {
                      type: "line",
                      "show-text": false,
                      percentage: _vm.uploadProgress
                    }
                  })
                ],
                1
              )
            ])
          : _vm._e(),
        _vm.step === 4
          ? _c("div", { staticClass: "recognition-area" }, [
              _c(
                "div",
                { staticClass: "recognition-info" },
                [
                  _c("el-input", {
                    ref: "recognitionContent",
                    attrs: {
                      type: "textarea",
                      placeholder:
                        _vm.placeholder ||
                        _vm.$t("SeaExport.RecognitionTextTip")
                    },
                    model: {
                      value: _vm.textContent,
                      callback: function($$v) {
                        _vm.textContent = $$v
                      },
                      expression: "textContent"
                    }
                  })
                ],
                1
              )
            ])
          : _vm._e(),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showTip,
                expression: "showTip"
              }
            ],
            staticClass: "ai-recognition-warn"
          },
          [
            _c("img", {
              attrs: {
                src: require("@/assets/icons/ai-recognition-bell.png"),
                alt: ""
              }
            }),
            _c("p", [_vm._v(_vm._s(_vm.$t("SeaExport.AiRecognitionWarn")))])
          ]
        )
      ]),
      _vm.step === 2 || _vm.step === 4
        ? _c(
            "span",
            {
              staticClass: "button-dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  staticStyle: {
                    width: "110px",
                    height: "40px",
                    "margin-right": "19px"
                  },
                  attrs: { size: "medium", plain: true },
                  on: {
                    click: function($event) {
                      _vm.innerVisible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Cancel")))]
              ),
              _c(
                "el-button",
                {
                  staticStyle: { width: "110px", height: "40px" },
                  attrs: { size: "medium", type: "primary" },
                  on: { click: _vm.startRecognitionHandler }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.StartRecognition")))]
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }